import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeQuantityFromPrintName',
})
export class RemoveQuantityFromPrintNamePipe implements PipeTransform {
  transform(printName: string, quantity: number): string {
    return quantity === 1 ? printName : printName.substring(printName.indexOf(' ') + 1);
  }
}
